// Theme state lives on <html data-theme>; index.html sets it before first paint.
const EVENT = 'themechange';

export function getTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function setTheme(theme) {
  const root = document.documentElement;
  // Switch instantly: suppress transitions for one frame so colours don't fade.
  root.classList.add('no-transitions');
  root.dataset.theme = theme;
  void window.getComputedStyle(root).opacity; // force a style flush
  requestAnimationFrame(() => root.classList.remove('no-transitions'));

  try {
    localStorage.setItem('theme', theme);
  } catch {
    // storage unavailable — theme just won't persist
  }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: theme }));
}

export function toggleTheme() {
  setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

export function onThemeChange(fn) {
  const handler = (e) => fn(e.detail);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
